import { forwardRef } from "react";
import Quill from "quill";

import Skeleton from "components/Skeleton";
import Editor from "./Editor";

import { useRenderStatus } from "hooks/useRenderStatus";

interface TextEditorProps {
  id?: string;
  label?: string;
  rightLabel?: string;
  readOnly?: boolean;
  backgroundReadOnlyVariant?: "white" | "gray";
  placeholder?: string;
  value?: string;
  name?: string;
  onChange?: (content: string, name?: string) => void;
  onBlur?: (hasValue: boolean) => void;
  onClick?: () => void;
}

const TextEditor = forwardRef<Quill, TextEditorProps>(
  (
    {
      id,
      label,
      rightLabel,
      readOnly,
      backgroundReadOnlyVariant = "white",
      placeholder,
      value = "",
      name,
      onChange,
      onBlur,
      onClick,
    },
    ref
  ) => {
    const busy = useRenderStatus(800);

    const handleChange = (content: string) => {
      if (onChange) onChange(content, name);
    };

    return (
      <div className="mb-5" onClick={onClick}>
        <div className="flex items-center justify-between gap-4">
          <div className="text-base mb-1.5 text-gray-500">{label}</div>
          <div className="text-sm mb-1.5 text-gray-900">{rightLabel}</div>
        </div>

        {busy ? (
          <Skeleton className="rounded-lg w-full h-[6rem]" />
        ) : (
          <Editor
            ref={ref}
            id={id}
            value={value}
            placeholder={placeholder}
            backgroundReadOnlyVariant={backgroundReadOnlyVariant}
            readOnly={readOnly}
            onChange={handleChange}
            onBlur={onBlur}
          />
        )}
      </div>
    );
  }
);

TextEditor.displayName = "TextEditor";

export default TextEditor;
